import { localized, msg } from "@lit/localize"
import { LitElement, html } from "lit"
import { customElement, property } from "lit/decorators.js"

@customElement("suggestion-icon")
@localized()
export class SuggestionIcon extends LitElement {
  /**
   * Color of the icon
   */
  @property({ type: String })
  color = "#000000"

  /**
   * Size of the icon
   */
  @property({ type: String })
  size = "16px"

  override render() {
    return html`
      <svg
        width=${this.size}
        height=${this.size}
        viewBox="0 0 16 16"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
      >
        <title>${msg("Suggestion icon")}</title>
        <g id="Suggestion" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <path
            d="M15.7779156,8.17533871 L12.1810436,7.01918172 L11.0248605,3.42207109 C10.9819796,3.28959143 10.8590972,3.19999167 10.7198944,3.19999167 C10.5806916,3.19999167 10.4578092,3.28959143 10.4152483,3.42207109 L9.25906518,7.01918172 L5.66219324,8.17533871 C5.52939059,8.2178986 5.4397888,8.34077828 5.4397888,8.47997792 C5.4397888,8.61917755 5.52939059,8.74205723 5.66187324,8.78461712 L9.25874517,9.94077411 L10.4149283,13.5378847 C10.4578092,13.6703644 10.5806916,13.7599642 10.7198944,13.7599642 C10.8590972,13.7599642 10.9819796,13.6703644 11.0245405,13.5378847 L12.1807236,9.94077411 L15.7775956,8.78461712 C15.9103982,8.74205723 16,8.61917755 16,8.47997792 C16,8.34077828 15.9103982,8.2178986 15.7779156,8.17533871 Z M0.538570771,4.14366921 L3.02694054,4.97310705 L3.85639713,7.46142057 C3.899918,7.59198023 4.02184044,7.67998 4.1597632,7.67998 C4.29768595,7.67998 4.4199284,7.59198023 4.46312926,7.46110057 L5.29258585,4.97278705 L7.78095562,4.14334921 C7.91183824,4.10014932 7.99984,3.97790964 7.99984,3.83999 C7.99984,3.70207036 7.91183824,3.57983068 7.78095562,3.53631079 L5.29258585,2.70687295 L4.46312926,0.218559431 C4.4199284,0.0879997708 4.29768595,-9.76996262e-15 4.1597632,-9.76996262e-15 C4.02184044,-9.76996262e-15 3.89959799,0.0879997708 3.85639713,0.21887943 L3.02694054,2.70687295 L0.538570771,3.53631079 C0.407688154,3.58015068 0.319686394,3.70207036 0.319686394,3.83999 C0.319686394,3.97790964 0.407688154,4.10014932 0.538570771,4.14366921 Z M5.54091082,12.1759683 L3.77255545,11.5865298 L3.18310366,9.81885443 C3.1399028,9.68829477 3.01766035,9.599975 2.87973759,9.599975 C2.74181484,9.599975 2.61957239,9.68797477 2.57637153,9.81885443 L1.98691974,11.5865298 L0.218884378,12.1759683 C0.0883217664,12.2194882 0,12.3417279 0,12.4796475 C0,12.6175671 0.08800176,12.7398068 0.218884378,12.7833267 L1.98723974,13.3727652 L2.57637153,15.1404406 C2.6198924,15.2706802 2.74181484,15.359 2.87973759,15.359 C3.01766035,15.359 3.1399028,15.2710002 3.18310366,15.1401206 L3.77255545,13.3724452 L5.54091082,12.7830067 C5.67179344,12.7394868 5.7597952,12.6172471 5.7597952,12.4796475 C5.7597952,12.3420479 5.67179344,12.2194882 5.54091082,12.1759683 Z"
            id="Shape"
            fill=${this.color}
            fill-rule="nonzero"
          ></path>
        </g>
      </svg>
    `
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "suggestion-icon": SuggestionIcon
  }
}
